import { FC, useState } from 'react'

import { SubscriptionPricesResponse } from 'src/services/subscriptionApi/interfaces/subscriptionApi.interface'

import SubscriptionCard, { SubscriptionCardData } from './SubscriptionCard'
import styles from './subscriptionCards.module.scss'
import { mergePricesWithFeatures } from './utils/mergePricesWithFeatures'

interface SubscriptionCardsProps {
  activePlanId?: string | null
  billingPeriod?: 'annually' | 'monthly'
  cancelDate?: string | null
  isCanceling?: boolean
  isMutatingPlan?: boolean
  isProcessing?: boolean
  isPromoApplied?: boolean
  onCancelPlan?: () => void
  onGetPlan?: (planId: string, priceId?: string) => void
  onResumePlan?: () => void
  pricesData?: SubscriptionPricesResponse
}

const SubscriptionCards: FC<SubscriptionCardsProps> = ({
  activePlanId = null,
  billingPeriod = 'monthly',
  cancelDate = null,
  isCanceling = false,
  isMutatingPlan = false,
  isProcessing = false,
  isPromoApplied = false,
  onCancelPlan,
  onGetPlan,
  onResumePlan,
  pricesData,
}) => {
  const [selectedCardId, setSelectedCardId] = useState<string | null>(null)

  const pricingData: SubscriptionCardData[] = mergePricesWithFeatures(
    pricesData,
    billingPeriod
  )

  return (
    <div className={styles.subscriptionCards}>
      {pricingData.map((card) => (
        <SubscriptionCard
          cancelDate={activePlanId === card.id ? cancelDate : null}
          data={card}
          isActivePlan={activePlanId === card.id}
          isCanceling={activePlanId === card.id && isCanceling}
          isMutatingPlan={isMutatingPlan}
          isProcessing={isProcessing}
          isPromoApplied={isPromoApplied}
          isSelected={selectedCardId === card.id}
          key={card.id}
          onCancel={onCancelPlan}
          onClick={() => setSelectedCardId(card.id)}
          onGetPlan={() => onGetPlan?.(card.id, card.priceId)}
          onResume={onResumePlan}
        />
      ))}
    </div>
  )
}

export default SubscriptionCards
